import {useResources} from '@/di/di.root-container.hooks';

import cn from 'classnames';

import {HttpError} from '@specials/project-user';

import {FrontendError} from '@/services/ErrorService/FrontendError';

import s from './ErrorRequestId.module.css';

export interface ErrorRequestIdProps {
  requestId?: string;
  error: FrontendError | HttpError | unknown;
  className?: string;
}

export function ErrorRequestId({requestId, error, className}: ErrorRequestIdProps): JSX.Element {
  const {
    content: {
      ErrorCodeMessage: {defaultErrorDescription},
    },
  } = useResources();

  const getErrorDescription = (): string => {
    if (requestId) {
      return requestId;
    }

    if (typeof error === 'object' && error !== null && 'message' in error) {
      return `${error.message}`;
    }

    return defaultErrorDescription;
  };

  return <span className={cn(s.request, className)}>{getErrorDescription()}</span>;
}
